'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  margin: auto !important;
  display: grid;
  gap: 1rem;
  column-gap: 3rem;
  padding-bottom: 1rem;
  background: white;
  grid-template-areas:
    'side'
    'header'
    'main'
    'breadcrumbs'
    'footer';
  @media screen and (width > ${theme.sizes.screens.md}) {
    grid-template-columns: clamp(200px, 250px, 33%) 1fr;
    grid-template-areas:
      'breadcrumbs breadcrumbs'
      'header header'
      'side main'
      'footer footer';
  }
`;

export const header = css`
  grid-area: header;
  @media screen and (width > ${theme.sizes.screens.md}) {
    position: sticky;
    top: calc(var(--layout-navbar) - 2px);
  }
`;

export const breadcrumbs = css`
  grid-area: breadcrumbs;
  min-width: 0;
  padding: 0 0.5rem;
  display: none;
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: initial;
  }
`;

export const ratings = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const side = css`
  grid-area: side;
`;

export const main = css`
  grid-area: main;
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1.25rem;
  z-index: 10;
  background-color: white;
  @media screen and (width > ${theme.sizes.screens.md}) {
    padding: initial;
  }
`;

export const footer = css`
  grid-area: footer;
  min-width: 0;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding-top: 2rem;
`;
